import {
  Box,
  Button,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { submitAnswerTrueFalse, useApi } from "../api/Api";
import * as React from "react";
import QuestionTrueFalseSolution from "./QuestionTrueFalseSolution";
import { useTranslation } from "react-i18next";
import QuestionDescription from "./QuestionDescription";

const QuestionTrueFalse = ({
  question,
  fetchQuizStats,
  fetchCurrentQuestion,
}) => {
  const { t } = useTranslation();
  const api = useApi();

  const [data, setData] = useState({});

  const [openAlert, setOpenAlert] = React.useState(false);
  const [feedback, setFeedback] = React.useState("");
  const [correct, setCorrect] = React.useState();
  const [solution, setSolution] = React.useState();
  const [changeQuestion, setChangeQuestion] = React.useState(false);

  let optionsOrder = {};
  question.answers.forEach((option, i) => (optionsOrder[option.id] = i));

  const handleClose = () => {
    setOpenAlert(false);
    setFeedback("");
    if (changeQuestion) fetchCurrentQuestion();
    fetchQuizStats();
  };

  useEffect(() => {
    if (!!feedback) setOpenAlert(true);
  }, [feedback]);

  const initData = () => {
    let foo = {};
    question["answers"].forEach((answer) => (foo[answer["id"]] = false));
    setData(foo);
  };

  useEffect(() => {
    initData();
  }, []);

  const updateData = (event, answerId) => {
    let dataCpy = JSON.parse(JSON.stringify(data));
    dataCpy[answerId] = event.target.checked;
    setData(dataCpy);
  };

  const checkboxes = question["answers"].map((answer) => (
    <FormControlLabel
      key={answer["id"]}
      control={
        <Checkbox
          key={answer["id"]}
          onClick={(event) => updateData(event, answer["id"])}
        />
      }
      label={answer["content"]}
    />
  ));

  const submitAnswer = (data) => {
    let dataToSubmit = { answers: [] };
    for (let [answerId, value] of Object.entries(data))
      dataToSubmit["answers"].push({ id: answerId, correct: value });

    submitAnswerTrueFalse(api, dataToSubmit)
      .then((response) => {
        let respData = response["data"];
        setCorrect(respData["correct"]);
        setFeedback(respData["feedback"]);
        setSolution(respData["solution"]);
        setChangeQuestion(respData["change_question"]);
      })
      .catch((error) => console.log(error));
  };

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Paper elevation={10} sx={{ m: 1, p: 1, maxWidth: 1000 }}>
        <CardContent>
          {/*<Typography variant="h6"*/}
          {/*            sx={{mb: 1}}>{t("question_type")}: {t("select_all_that_apply")}</Typography>*/}
          {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_no")} {question["questionid"]}</Typography>*/}
          <QuestionDescription description={question["description"]} />
          <FormGroup>{checkboxes}</FormGroup>
        </CardContent>
        <Box textAlign="center" xs={{ m: 2 }}>
          <Button variant="contained" onClick={() => submitAnswer(data)}>
            {t("submit_answer")}
          </Button>
        </Box>
      </Paper>
      <Dialog
        open={openAlert}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {correct ? t("correct_answer") : t("incorrect_answer")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {feedback}
            {solution === undefined ? (
              <></>
            ) : (
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  {t("solution")}
                </Typography>
                <QuestionTrueFalseSolution
                  question={solution}
                  data={data}
                  optionsOrder={optionsOrder}
                />
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("close")}</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default QuestionTrueFalse;
